export default function escapeRegExp(text: string) {
	return String(text).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
